angular.module(NgAppName).component('crVideoTourList', {
	templateUrl: 'crVideoTourList.html',
	bindings: {
		listings: '<',
		missingImage: '@',
		rpcListingPopup: '@'
	},
	controller: ['$timeout', '$element', '$sce' ,'crResourcesService', 'ImageService' ,'gVariables', function($timeout, $element, $sce, crResourcesService, ImageService, gVariables) {
		let ctrl = this;

		// crResourcesService.get(this.rpcUrl).$promise.then(function(data) {
		// 	if (data) {
		// 		ctrl.rows = data.agents;

		// 		ctrl.rows.push({
		// 			autocompleteName: 'agent',
		// 			autocompleteModel: {},
		// 			autocompleteAgent: true,
		// 			empty: true
		// 		});
		// 	}
		// }, function(error) {
		// 	// todo manage errors
		// }).finally(function() {
		// 	// hide loader
		// 	$element[0].querySelector('.cr_loader').style.display = 'none';
		// });

		if (Core.is_ie() || Core.is_edge()) {
			this.onIE = true;
		}

		this.trustUrl = function (url) {
			return $sce.trustAsResourceUrl(url);
		};

		this.getImage = (listing, index) => {
			if (index === 3 || index === 12 || index === 21) {
				return this.getImageUrlBig(listing);
			}
			return this.getImageUrlSmall(listing);
		}; 

		this.getImageUrlSmall = (listing) => {
			return this.getImageUrl(321, 193, listing);
		}; 
		
		this.getImageUrlBig = (listing) => {
			return this.getImageUrl(664, 520, listing);
		}; 

		this.getImageUrl = (width, height, listing) => {
			return listing.thumbor_images && listing.thumbor_images.length > 0 ? ImageService.getSmartImage(width, height, listing.thumbor_images[0], 'smart') : this.missingImage;
		};

		this.getListingClass = (index) => {
			index = index % 9;
			if (index === 0 || index === 3 || index === 6) {
				return 'listing-mr';
			} else if (index === 1 || index === 7) {
				return 'listing-mlr';
			} else if (index === 2 || index === 4 || index === 5 || index === 8) {
				return 'listing-ml';
			}
			return '';
		};

		this.openPopup = (event, listing, type) => {
			event.stopPropagation();

			if (!listing.blimp) {
				let videoLink = event.target.closest('.video-link');

				listing.blimp = new BlimpExt(videoLink, {
					draggable: true,
					show_veil: true,
					display: type,
					onFetch: function() {
						if (listing.markerLabel) {
							listing.markerLabel.marker.clicked = true;
						}

						_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
					},
					onPostRpc: function() {
						this.add_extra();
					}
				}); 
			}

			listing.blimp.handle_link_click();

		};
		
	}]
});
